import { useTranslation } from 'react-i18next'
import Button from '@/components/ui/Button'

interface ErrorFallbackProps {
  error: Error
  resetError: () => void
}

export function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="mx-auto max-w-md px-4 text-center">
        <h1 className="mb-2 text-heading-xl font-bold">
          {t('errors.boundary.title')}
        </h1>
        <p className="mb-6 text-muted-foreground">
          {t('errors.boundary.body')}
        </p>
        {import.meta.env.DEV && (
          <pre className="mb-6 max-h-40 overflow-auto rounded bg-gray-100 p-3 text-start text-body-sm text-gray-700">
            {error.message}
          </pre>
        )}
        <Button
          variant="text"
          onClick={resetError}
          className="text-primary underline hover:text-primary/90"
        >
          {t('errors.boundary.tryAgain')}
        </Button>
      </div>
    </div>
  )
}
